import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/useHttp";

export const getAllSets = createAsyncThunk("sets/getAll", async () => {
  const { request } = useHttp();
  return await request({
    url: "/blog/category/list/",
  });
});
